import type { CatalogBundleStorefrontDto } from '@VelocitySquared/sunny16-commerce-dataobjects/storefront'

/**
 * Extracts bullet-point features from the bundle's `descriptionBasic`
 * field (newline-delimited plain text from the API).
 */
export function extractDescriptionBullets(dto: CatalogBundleStorefrontDto): string[] {
  const description = dto.bundle?.descriptionBasic
  if (!description) return []
  return description
    .split('\n')
    .map((line) => line.replace(/^\uFEFF/, '').trim())
    .filter(Boolean)
}

/**
 * Reads a CADY attribute value from item-level attributes within a bundle.
 * Returns undefined if the attribute is not found.
 *
 * Searches items inside the "Included Items" group.
 */
export function getBundleIncludedGroupItemAttribute(
  dto: CatalogBundleStorefrontDto,
  attributeKey: string
): string | undefined {
  const includedGroup = dto.bundle?.itemGroups.find((g) => g.isIncluded)
  if (!includedGroup?.itemGroupItems) return undefined
  for (const groupItem of includedGroup.itemGroupItems) {
    const attr = groupItem.item?.attributes?.find((a) => a.key === attributeKey)
    if (attr) return attr.value
  }
  return undefined
}

/**
 * Returns the CADY_SessionCard attribute value from a CatalogBundleStorefrontDto.
 * This value (e.g. "mostpopular", "legacy") identifies the session card type.
 */
export function getSessionCardKey(dto: CatalogBundleStorefrontDto): string | undefined {
  const bundle = dto.bundle as unknown as
    | { attributes?: { key: string; value: string }[] }
    | null
    | undefined
  return bundle?.attributes?.find((a) => a.key === 'CADY_SessionCard')?.value
}
